import React from 'react'
import {
  CButton,
} from '@coreui/react-pro'
import { styleButtonVars3, styleButtonVars6 } from '../custom-styles/buttonStyles'


const AppCardHeader = ({
  id,
  headerTitle,
  headerButton,
  headerDeleteButton,
  headerDownloadButton,
  handleCardHeaderButton,
  setShowConfirmDelete,
  downloadLink,
  downloadName,
  disabled
}) => {
  return (
    <div className="d-flex justify-content-between align-items-center">
      <div>
      {headerTitle}
      </div>
      <div className="d-flex gap-2">
      {headerButton && (
        <CButton
          style={styleButtonVars3}
          onClick={() => handleCardHeaderButton()}
          disabled={disabled}
        >
          {headerButton}
        </CButton>
      )}
      {headerDeleteButton && (
        <CButton
          style={styleButtonVars6}
          onClick={() => setShowConfirmDelete({ show: true, item: { id } })}
          disabled={disabled}
        >
          Delete
        </CButton>
      )}
      {headerDownloadButton && (
        <CButton
          target="__blank"
          style={styleButtonVars3}
          href={downloadLink}
          download={downloadName}
          disabled={disabled}
        >
          {headerDownloadButton}
        </CButton>
      )}
      </div>
    </div>
  )
}

export default AppCardHeader
